import { render, staticRenderFns } from "./KeyVisual.vue?vue&type=template&id=12d8cd3b&scoped=true"
import script from "./KeyVisual.vue?vue&type=script&lang=ts"
export * from "./KeyVisual.vue?vue&type=script&lang=ts"
import style0 from "./KeyVisual.vue?vue&type=style&index=0&id=12d8cd3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8cd3b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewMore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/view-more.vue').default})
